import MyProfile from './MyProfile'

export {default as AccountSettings} from './AccountSettings'
export {default as Logoff} from './Logoff'
export {default as PublicProfile} from './PublicProfile'
export {default as ProfileInformation} from './ProfileInformation'
export {default as AdminArea} from './AdminArea'

export default MyProfile
